import { isEmpty } from "lodash";

export const updateValidator = (value: any) => {
  const errors: any = {};

  if (!value.name) {
    errors.name = "Required";
  }

  if (!value.role) {
    errors.role = "Required";
  }

  return errors;
};

export const updateMassUsersValidator = (values: any) => {
  const errors: any = {};

  if (!values.users || !values.users.length) {
    errors.users = { _error: "At least one member must be entered" };
  } else {
    const usersErrors: any[] = [];
    values.users.forEach((user: any, index: number) => {
      const usersError: any = {};

      if (!user || !user.name) {
        usersError.name = "Required";
        usersErrors[index] = usersError;
      }
      if (!user || !user.role) {
        usersError.role = "Required";
        usersErrors[index] = usersError;
      }

      if (!user || !user.phone) {
        usersError.phone = "Required";
        usersErrors[index] = usersError;
      }
      // if (!user || !user.location) {
      //   usersError.location = "Required";
      //   usersErrors[index] = usersError;
      // }
    });

    if (!isEmpty(usersErrors)) {
      errors.users = usersErrors;
    }
  }

  return errors;
};
